import React, { useState, useEffect, useContext } from "react";
import {
  Container,
  Grid,
  Typography,
  FormControl,
  InputLabel,
  Select,
  OutlinedInput,
  MenuItem,
  Chip,
  Box,
  Card,
  CardContent,
  Paper,
  AppBar,
  Hidden,
  Tabs,
  Tab,
  Divider,
  Snackbar,
  Button,
  Alert,
  IconButton,
  FormHelperText,
  Stack,
} from "@mui/material";

import { styled } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import _without from "lodash/without";
import { PropTypes } from "prop-types";
import { useTheme } from "@mui/material/styles";
import SwipeableViews from "react-swipeable-views";

//... Common components
import { AppDataContext } from "../../common/appContext";
import { handleError } from "../../helper";

//... Icons Imports
import CancelIcon from "@mui/icons-material/Cancel";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";

//... Component Imports
import IndividualPercentileAnthros from "./IndividualPercentileAnthros";
import IndividualPercentileShootingDrills from "./IndividualPercentileShootingDrills";
import IndividualPercentileStrengthAndAgility from "./IndividualPercentileStrengthAndAgility";

//... Service call imports
import { HistoricalCombineResultServices } from "../../services/historicalGroupCombine.Service";
import { AdminPreferencesService } from "../../services/adminPref.Service";
import { PlayerProfileService } from "../../services/playerProfile.Service";

//...Mock data imports.
import statData from "../../mockData/individualComparisionData.json";

import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "../../sharedComponents/Accordion/Accordion";

const useStyles = makeStyles((theme) => ({
  headerBox: {
    background: "#1d428a",
  },
  headerText: {
    //marginBottom: theme.spacing(0.5),
    color: "#fff",
  },
  subHeaderText: {
    // color: "rgb(29, 66, 138)",
    fontWeight: "500",
  },
  compareGroupCard: {
    "& .MuiCardHeader-root": {
      padding: "10px 0px 0px 16px",
    },
    "& .MuiCardContent-root ": {
      padding: "10px 10px 16px 10px",
    },
    "& .MuiButtonBase-root ": {
      height: "25px",
    },
    "& .MuiChip-deleteIcon ": {
      fontSize: "18px",
    },
    "& .MuiChip-label": {
      paddingLeft: "6px",
      paddingRight: "6px",
    },
  },
  customDivider: {
    marginTop: "8px",
    marginBottom: "8px",
    "&.MuiDivider-root": {
      "&::before": {
        borderTop: "4px solid #1d428a",
      },
      "&::after": {
        borderTop: "4px solid #1d428a",
      },
    },
    "& .MuiDivider-wrapper": {
      fontSize: 16,
    },
  },
  appbar: {
    backgroundColor: "#f5f5f5",
    color: "#000000",
    "& .Mui-selected": {
      color: theme.palette.primary.main,
    },
  },
}));

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const eventList = [
  {
    leagueId: "21",
    eventName: "Gleague Elite Camp",
  },
  {
    leagueId: "11",
    eventName: "Basketball Africa League",
  },
  {
    leagueId: "09",
    eventName: "NBA Draft Combine",
  },
  {
    leagueId: "23",
    eventName: "Portsmouth",
  },
];

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const colorSchemaForGroups = {
  0: "rgb(186 28 28 / 87%)",
  1: "rgb(32 66 132)",
  2: "rgb(44, 160, 44)",
  3: "rgb(255, 127, 14)",
  4: "rgb(127, 127, 127)",
};

const intialStats = {
  anthros: [
    {
      groupID: 1,
      data: [],
      avg: {},
      percentile: {},
    },
    {
      groupID: 2,
      data: [],
      avg: {},
      percentile: {},
    },
  ],
  strengthAndAgility: [
    {
      groupID: 1,
      data: [],
      avg: {},
      percentile: {},
    },
    {
      groupID: 2,
      data: [],
      avg: {},
      percentile: {},
    },
  ],
  shootingDrills: [
    {
      groupID: 1,
      data: [],
      avg: {},
      percentile: {},
    },
    {
      groupID: 2,
      data: [],
      avg: {},
      percentile: {},
    },
  ],
};

const intialAccordion = {
  anthros: [
    {
      groupID: 1,
      expanded: true,
    },
    {
      groupID: 2,
      expanded: true,
    },
  ],
  strengthAndAgility: [
    {
      groupID: 1,
      expanded: true,
    },
    {
      groupID: 2,
      expanded: true,
    },
  ],
  shootingDrills: [
    {
      groupID: 1,
      expanded: true,
    },
    {
      groupID: 2,
      expanded: true,
    },
  ],
};

const IndividualCombineResult = ({ showAlert, loading, setLoading }) => {
  const classes = useStyles();
  const theme = useTheme();
  const { user, selectedEventId } = useContext(AppDataContext);

  //... Default data variables
  const currentCombineYear = 2024;
  const currentEventID = "09";

  //... Common state holders.
  const [stats, setStats] = useState(intialStats);
  const [eventId, setEventId] = useState(selectedEventId);
  const [combineEvents, setCombineEvents] = useState(eventList);
  const [combineYearOptions, setCombineYearOptions] = useState([]);
  const [combinePositions, setCombinePositions] = useState([]);
  const [combinePlayerList, setCombinePlayerList] = useState([]);
  const [expanded, setExpanded] = useState(true);
  const [selectedTab, setSelectedTab] = useState(0);
  const [expandedGroups, setExpandedGroups] = useState(intialAccordion);

  //... Filter State holders.
  const [filter, setFilter] = useState([
    {
      groupID: 1,
      states: {
        event: [currentEventID],
        year: currentCombineYear,
        position: "",
        collegeOrSchool: "",
        players: [],
        positionOptions: [],
        collegeOrSchoolOptions: [],
        playersOptions: [],
        playerList: [],
      },
    },
    {
      groupID: 2,
      states: {
        event: [currentEventID],
        year: currentCombineYear,
        position: "",
        collegeOrSchool: "",
        players: [],
        positionOptions: [],
        collegeOrSchoolOptions: [],
        playersOptions: [],
        playerList: [],
      },
    },
  ]);

  //... Station wise percentile Chart Data holders.
  const [anthroPercentileStats, setAnthroPercentileStats] = useState([]);
  const [
    strengthAndAgilityPercentileStats,
    setStrengthAndAgilityPercentileStats,
  ] = useState([]);
  const [shootingDrilsPercentileStats, setShootingDrilsPercentileStats] =
    useState([]);

  //... Station wise AVG Chart Data holders.
  const [anthroAVGStats, setAnthroAVGStats] = useState([]);
  const [strengthAndAgilityAVGStats, setStrengthAndAgilityAVGStats] = useState(
    []
  );
  const [shootingDrilsAVGStats, setShootingDrilsAVGStats] = useState([]);

  //... Error data holders.
  const [errors, setErrors] = useState([]);

  //... UseEffects
  useEffect(() => {
    async function fetchPreData() {
      await Promise.all([
        GetCombineYearData(),
        GetAllPositions(),
        GetAllPlayers(currentCombineYear, currentEventID),
        // SearchWithCurrentFilters(),
      ]);
    }

    fetchPreData();
  }, []);

  // useEffect(() => {
  //   if (
  //     (combineEvents && combineEvents.length > 0) ||
  //     (combineYearOptions && combineYearOptions.length > 0)
  //   ) {
  //     setFilter((prevFilter) =>
  //       prevFilter.map((filterItem) => ({
  //         ...filterItem,
  //         states: {
  //           ...filterItem.states,
  //           event:
  //             combineEvents && combineEvents.length > 0
  //               ? [currentEventID]
  //               : filterItem.states.event,
  //           year:
  //             combineYearOptions && combineYearOptions.length > 0
  //               ? currentCombineYear
  //               : filterItem.states.year,
  //         },
  //       }))
  //     );
  //   }
  // }, [combineEvents, combineYearOptions]);

  useEffect(() => {
    //SET PERCENTILE DATA TO SHOW GRAPH
    setAnthroPercentileStats(formatedAnthrosGraphStatsData(stats.anthros));
    setStrengthAndAgilityPercentileStats(
      formatedSASGraphStatsData(stats.strengthAndAgility)
    );
    setShootingDrilsPercentileStats(
      formattedShootingGraphStatsData(stats.shootingDrills)
    );

    //SET AVERAGE DATA TO SHOW GRAPH
    setAnthroAVGStats(formatedAnthrosAvgGraphStatsData(stats.anthros));
    setStrengthAndAgilityAVGStats(
      formatedSASGraphAvgStatsData(stats.strengthAndAgility)
    );
    setShootingDrilsAVGStats(
      formattedShootingAvgGraphStatsData(stats.shootingDrills)
    );
  }, [stats]);

  //...Event Handlers
  const handleChange = async (index, field, event) => {
    event.preventDefault();
    const { value } = event.target;

    let updatedFilter = [...filter];
    updatedFilter[index].states[field] = ["players", "event"].includes(field)
      ? Array.isArray(value)
        ? value
        : value.split(",")
      : value;

    // Filter Data based on change for event, year, and position fields
    if (["event", "year"].includes(field)) {
      updatedFilter = await loadDependencyOnEventChange(index, updatedFilter);
    }

    if (["position", "collegeOrSchool"].includes(field)) {
      const filterEventPosition = updatedFilter[index].states["position"];
      const filterEventCollegeOrSchool =
        updatedFilter[index].states["collegeOrSchool"];
      const filteredPlayerList = updatedFilter[index].states["playerList"];

      if (field === "position") {
        const filteredPlayers = filterEventPosition
          ? filteredPlayerList.filter(
              (player) => player.positionName === filterEventPosition
            )
          : filteredPlayerList;

        const collegeList = [
          ...new Set(filteredPlayers?.map((player) => player.collegeOrClub)),
        ];
        updatedFilter[index].states["players"] = [];
        updatedFilter[index].states["collegeOrSchool"] = "";
        updatedFilter[index].states["playersOptions"] = filteredPlayers || [];
        updatedFilter[index].states["collegeOrSchoolOptions"] =
          collegeList || [];
      }

      if (field === "collegeOrSchool") {
        let filteredPlayers = filterEventPosition
          ? filteredPlayerList.filter(
              (player) => player.positionName === filterEventPosition
            )
          : filteredPlayerList;

        if (filterEventCollegeOrSchool) {
          filteredPlayers = filteredPlayers.filter(
            (player) => player.collegeOrClub === filterEventCollegeOrSchool
          );
        }
        updatedFilter[index].states["players"] = [];
        updatedFilter[index].states["playersOptions"] = filteredPlayers || [];
      }
    }
    setFilter(updatedFilter);

    // SearchWithCurrentFilters();
  };

  //...
  const loadDependencyOnEventChange = async (index, updatedFilter) => {
    const filterEventIDs = updatedFilter[index].states["event"];
    const filterEventYear = updatedFilter[index].states["year"];

    updatedFilter[index].states["players"] = [];
    updatedFilter[index].states["position"] = "";
    updatedFilter[index].states["collegeOrSchool"] = "";
    updatedFilter[index].states["playersOptions"] = [];
    updatedFilter[index].states["collegeOrSchoolOptions"] = [];
    updatedFilter[index].states["playerList"] = [];

    if (filterEventIDs && filterEventIDs.length > 0) {
      const playerMap = new Map();
      await Promise.all(
        filterEventIDs.map(async (filterEventID) => {
          const combineEventID = parseInt(`${filterEventYear}${filterEventID}`);
          if (combineEventID) {
            const { data } = await GetAllPrimaryPlayers(combineEventID);
            data.forEach((player) => playerMap.set(player.playerName, player));
          }
        })
      );
      const rawPlayerData = Array.from(playerMap.values());

      updatedFilter[index].states["playersOptions"] = rawPlayerData || [];
      updatedFilter[index].states["collegeOrSchoolOptions"] =
        [...new Set(rawPlayerData?.map((player) => player.collegeOrClub))] ||
        [];
      updatedFilter[index].states["playerList"] = rawPlayerData || [];
    }

    return updatedFilter;
  };

  const handleDeleteEntity = async (index, field, e, value) => {
    e.preventDefault();
    let updatedFilter = [...filter];
    updatedFilter[index].states[field] = _without(
      updatedFilter[index].states[field],
      value
    );

    if (field === "event") {
      updatedFilter = await loadDependencyOnEventChange(index, updatedFilter);
    }

    setFilter(updatedFilter);
    // SearchWithCurrentFilters(updatedFilter);
  };

  const handleAddButtonClick = () => {
    if (filter && filter.length === 5) {
      showAlert(
        true,
        "warning",
        "You can only add up to five comparison groups."
      );
      return;
    }

    const collegeList = Array.from(
      new Set(combinePlayerList?.map((player) => player.collegeOrClub))
    );

    setFilter((prevFilter) => {
      const aFindMissingGroupIDs = findMissingGroupIDs(prevFilter);

      const newFilter = [
        ...prevFilter,
        {
          groupID:
            aFindMissingGroupIDs.length > 0
              ? aFindMissingGroupIDs[0]
              : prevFilter.length + 1,
          states: {
            event: [currentEventID],
            year: currentCombineYear,
            position: "",
            collegeOrSchool: "",
            players: [],
            positionOptions: combinePositions,
            collegeOrSchoolOptions: collegeList,
            playersOptions: combinePlayerList,
            playerList: combinePlayerList,
          },
        },
      ];

      // Sort the previous filter by groupID
      newFilter.sort((a, b) => a.groupID - b.groupID);

      // SearchWithCurrentFilters(newFilter);

      return newFilter;
    });

    addGroupsExapndItem();
  };

  const handleSearchButtonClick = async () => {
    try {
      if (!validatePayload(filter)) {
        const dummyResponse = buildDummyResponse(filter);
        setStats(dummyResponse);
        return;
      }

      //... Close Filter Accordion
      setExpanded(false);

      setLoading(true);
      const payload = createPayload(filter);
      await GetIndividualComparisionData(payload);
    } catch (error) {
      console.error("Error occurred while fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  function findMissingGroupIDs(groups) {
    let maxGroupID = 0;
    const existingIDs = new Set(
      groups.map((group) => {
        maxGroupID = Math.max(maxGroupID, group.groupID);
        return group.groupID;
      })
    );

    const missingIDs = [];

    for (let i = 1; i <= maxGroupID; i++) {
      if (!existingIDs.has(i)) {
        missingIDs.push(i);
      }
    }

    return missingIDs;
  }

  const addGroupsExapndItem = () => {
    setExpandedGroups((prevAccordion) => {
      const newAccordion = {};
      for (const key in prevAccordion) {
        if (Object.hasOwnProperty.call(prevAccordion, key)) {
          const newArray = [
            ...prevAccordion[key],
            {
              groupID:
                prevAccordion[key].length > 0
                  ? prevAccordion[key][prevAccordion[key].length - 1].groupID +
                    1
                  : 1,
              expanded: true,
            },
          ];
          newAccordion[key] = newArray;
        }
      }
      return newAccordion;
    });
  };

  const removeGroupsExapndItem = (groupID) => {
    setExpandedGroups((prevAccordion) => {
      const newAccordion = {};
      for (const key in prevAccordion) {
        if (Object.hasOwnProperty.call(prevAccordion, key)) {
          const newArray = prevAccordion[key].filter(
            (item) => item.groupID !== groupID
          ); // Filter out the item with the specified groupID
          newAccordion[key] = newArray;
        }
      }
      return newAccordion;
    });
  };

  const addGroupFilterIdToAllSections = () => {
    const newFilter = {
      data: [],
      avg: {},
      percentile: {},
    };

    const updatedStats = { ...stats };
    Object.keys(updatedStats).forEach((section) => {
      const nextId = updatedStats[section].length + 1;
      updatedStats[section].push({ groupID: nextId, ...newFilter });
    });

    setStats(updatedStats);
  };

  const handleDeleteGroup = (groupID) => {
    setFilter((prevFilter) => {
      const newFilter = prevFilter.filter((item) => item.groupID !== groupID);
      return newFilter;
    });

    setStats((prevStats) => ({
      ...prevStats,
      anthros: prevStats.anthros.filter((item) => item.groupID !== groupID),
      strengthAndAgility: prevStats.strengthAndAgility.filter(
        (item) => item.groupID !== groupID
      ),
      shootingDrills: prevStats.shootingDrills.filter(
        (item) => item.groupID !== groupID
      ),
    }));

    removeGroupsExapndItem(groupID);
  };

  const handleGroupAccordionChange = (source, index) => {
    setExpandedGroups((prevItem) => ({
      ...prevItem,
      [source]: prevItem[source].map((item, i) =>
        i === index ? { ...item, expanded: !item.expanded } : item
      ),
    }));
  };

  const handleChangeTab = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const handleChangeIndex = (index) => {
    setSelectedTab(index);
  };

  //... Service call for get all Active Combine Years Data
  const GetCombineYearData = async () => {
    try {
      const response = await AdminPreferencesService.getCombineYears({});
      const combineYearData = response.data.map((item) => item.eventYear);
      setCombineYearOptions(combineYearData);
    } catch (error) {
      handleError(error);
    }
  };

  //... Service call for get all Active positions.
  const GetAllPositions = async () => {
    try {
      const response = await PlayerProfileService.getPlayerPositions();
      const playingPositions = response.data.map((item) => item.childName);
      const sortedPositions = playingPositions.sort((a, b) =>
        a.localeCompare(b)
      );

      // Update positionOptions in all filter states
      setFilter((prevFilter) =>
        prevFilter.map((filterItem) => ({
          ...filterItem,
          states: {
            ...filterItem.states,
            positionOptions: sortedPositions,
          },
        }))
      );

      setCombinePositions(sortedPositions || []);
    } catch (error) {
      handleError(error);
    }
  };

  //... Service call for get all players.
  const GetAllPlayers = async (year, event) => {
    const combineEventID = parseInt(`${year}${event}`);

    if (combineEventID) {
      GetAllPrimaryPlayers(combineEventID)
        .then((result) => {
          const collegeList = [
            ...new Set(result?.data?.map((player) => player.collegeOrClub)),
          ];

          // Update College options and players in all filter states
          setFilter((prevFilter) =>
            prevFilter.map((filterItem) => ({
              ...filterItem,
              states: {
                ...filterItem.states,
                playersOptions: result?.data || [],
                playerList: result?.data || [],
                collegeOrSchoolOptions: collegeList || [],
              },
            }))
          );

          setCombinePlayerList(result?.data || []);
        })
        .catch((error) =>
          console.error(`Error retrieving ${event} players:`, error)
        );
    }
  };

  //... GET ALL PLAYERS BY EVENT ID.
  const GetAllPrimaryPlayers = async (iEventID) => {
    return await PlayerProfileService.getPlayerListByEventIdYear(iEventID);
  };

  async function SearchWithCurrentFilters(currentPayload = null) {
    if (!validatePayload(currentPayload || filter)) {
      const dummyResponse = buildDummyResponse(currentPayload || filter);
      setStats(dummyResponse);
      return;
    }

    setLoading(true);

    const payload = createPayload(currentPayload || filter);
    await GetIndividualComparisionData(payload);
  }

  //... Service call to get Individual Comparison Data
  const GetIndividualComparisionData = async (obj) => {
    setStats(intialStats);
    try {
      const { data } =
        await HistoricalCombineResultServices.getIndividualStatsComparison(obj);
      if (
        !data.anthros.length &&
        !data.strengthAndAgility.length &&
        !data.shootingDrills.length
      ) {
        setStats(buildDummyResponse(obj));
      } else {
        setStats(data);
      }
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  //... Returns Anthros percentile graph data
  const formatedAnthrosGraphStatsData = (data) => {
    let categories = [
      { name: "Standing Reach", prop: "standingReach" },
      { name: "Wingspan Dimension", prop: "wingSpan" },
      { name: "Height Without Shoes", prop: "heightWithOutShoes" },
      // { name: "Weight", prop: "bodyWeight" },
      { name: "Hand Dimension Width", prop: "handWidth" },
      { name: "Hand Dimension Length", prop: "handLength" },
    ];

    return createFormatedDataStats(categories, data);
  };

  const formatedSASGraphStatsData = (data) => {
    let categories = [
      { name: "Lane Shuttle Left", prop: "shuttleRunLeftTrialTime" },
      { name: "Lane Shuttle Right", prop: "shuttleRunRightTrialTime" },
      { name: "3/4 Court Sprint", prop: "threeFourRunTime" },
      { name: "Pro Lane", prop: "proLaneTrialTime" },
      { name: "Max Vertical Jump", prop: "maxVerticalLeap" },
      { name: "Standing Vertical", prop: "standingVerticalLeap" },
    ];

    return createFormatedDataStats(categories, data);
  };

  const formattedShootingGraphStatsData = (data) => {
    let categories = [
      { name: "Spot Up Shooting", prop: "spotUpShooting" },
      { name: "Side Mid Side Drill", prop: "sideMidSideDrill" },
      { name: "Mid Side Mid Drill", prop: "midSideMid" },
      { name: "Off The Dribble Shooting", prop: "offTheDribbleShooting" },
      { name: "Free Throws", prop: "freeThrows" },
      { name: "3 Point Star Drill", prop: "threePointStar" },
      { name: "Mid Range Star Drill", prop: "midRangeStar" },
    ];

    return createFormatedDataStats(categories, data);
  };

  //... Returns Anthros AVG graph data
  const formatedAnthrosAvgGraphStatsData = (data) => {
    const categories = [
      {
        category: `Standing Reach (Inches)`,
        feetKey: "standingReachFeet",
        inchesKey: "standingReachInches",
      },
      {
        category: "Wingspan Dimension (Inches)",
        feetKey: "wingSpanFeet",
        inchesKey: "wingSpanInches",
      },
      {
        category: "Height Without Shoes (Inches)",
        feetKey: "heightWithOutShoesFeet",
        inchesKey: "heightWithOutShoesInches",
      },
      // { category: "Weight", key: "bodyWeight" },
      { category: "Hand Dimension Width", key: "handWidth" },
      { category: "Hand Dimension Length", key: "handLength" },
    ];

    data?.forEach((element, index) => {
      const { avg } = element;
      categories.forEach((category) => {
        if (category.feetKey && category.inchesKey) {
          category[`group${index + 1}Avg`] = calculatePercentile(
            avg,
            category.feetKey,
            category.inchesKey
          );
        } else {
          category[`group${index + 1}Avg`] =
            validateNumber(avg?.[category.key]) || 0;
        }
      });
    });
    return categories;
  };

  const formatedSASGraphAvgStatsData = (data) => {
    let categories = [
      { name: "Lane Shuttle Left", prop: "shuttleRunLeftTrialTime" },
      { name: "Lane Shuttle Right", prop: "shuttleRunRightTrialTime" },
      { name: "3/4 Court Sprint", prop: "threeFourRunTime" },
      { name: "Pro Lane", prop: "proLaneTrialTime" },
      { name: "Max Vertical Jump", prop: "maxVerticalLeap" },
      { name: "Standing Vertical", prop: "standingVerticalLeap" },
    ];

    return createCommonFormatedAvgDataStats(categories, data);
  };

  const formattedShootingAvgGraphStatsData = (data) => {
    let categories = [
      { name: "Spot Up Shooting", prop: "noOfMadeSpotup" },
      { name: "Side Mid Side Drill", prop: "noOfMadeSideMidSide" },
      { name: "Mid Side Mid Drill", prop: "noOfMadeMidSideMid" },
      { name: "Off The Dribble Shooting", prop: "noOfMadeOffTheDribble" },
      { name: "Free Throws", prop: "noOfMadeFreeThrows" },
      { name: "3 Point Star Drill", prop: "noOfMade3PointStar" },
      { name: "Mid Range Star Drill", prop: "noOfMadeMidRangeStar" },
    ];

    return createCommonFormatedAvgDataStats(categories, data);
  };

  //... Utility to formatted percentile datsets for graph.
  const createFormatedDataStats = (categories, data) => {
    let dataSet = categories.map((category) => ({ category: category.name }));

    if (data && data.length > 0) {
      data.forEach((item, index) => {
        const { percentile } = item;
        categories.forEach((category, idx) => {
          dataSet[idx][`group${index + 1}Percentile`] = validateNumber(
            percentile?.[category.prop] || 0
          );
        });
      });
    }
    return dataSet;
  };

  //... Utility to formatted AVG datsets for graph.
  const createCommonFormatedAvgDataStats = (categories, data) => {
    let dataSet = categories.map((category) => ({ category: category.name }));

    if (data && data.length > 0) {
      data.forEach((item, index) => {
        const { avg } = item;
        categories.forEach((category, idx) => {
          dataSet[idx][`group${index + 1}Avg`] = validateNumber(
            avg?.[category.prop] || 0
          );
        });
      });
    }
    return dataSet;
  };

  //... Utility to calculate percentile value of feet and inches to inches.
  const calculatePercentile = (avg, feetKey, inchesKey) => {
    const feet = avg?.[feetKey] || 0;
    const inches = avg?.[inchesKey] || 0;
    return validateNumber(feet * 12 + inches);
  };

  //... Utility to create payload
  const createPayload = (currentData) => {
    const payload = currentData.map((data) => ({
      groupID: data.groupID,
      event: data.states.event.map((event) =>
        parseInt(`${data.states.year}${event}`)
      ),
      year: data.states.year,
      position: data.states.position,
      players: data.states.players,
      collegeOrSchool: data.states.collegeOrSchool,
    }));
    return payload;
  };

  //... Utility to validate payload
  const validatePayload = (payload) => {
    const newErrors = [];

    payload.forEach((group, groupIndex) => {
      const groupErrors = {};

      // Check specific fields for errors
      if (group.states.event.length === 0) {
        groupErrors.event = true;
      }
      if (!group.states.year) {
        groupErrors.year = true;
      }
      if (group.states.players.length === 0) {
        groupErrors.players = true;
      }

      newErrors[groupIndex] = groupErrors;
    });
    setErrors(newErrors);
    return newErrors.every((errors) => Object.keys(errors).length === 0);
  };

  //...Utility to build dummy response if server fails to generate to avoid client-side failuer..
  const buildDummyResponse = (data) => {
    const createGroup = (groupID) => ({
      groupID,
      data: [],
      avg: null,
      percentile: null,
    });

    const dummyResponse = {
      anthros: [],
      strengthAndAgility: [],
      shootingDrills: [],
    };

    data?.forEach((item, index) => {
      dummyResponse.anthros[index] = createGroup(item.groupID);
      dummyResponse.strengthAndAgility[index] = createGroup(item.groupID);
      dummyResponse.shootingDrills[index] = createGroup(item.groupID);
    });

    return dummyResponse;
  };

  // Validate given value is number or not
  const validateNumber = (num) => {
    const parsedNum = Number(num);
    if (isNaN(parsedNum)) {
      return 0;
    }
    return Number.isInteger(parsedNum) ? parsedNum : parsedNum.toFixed(2);
  };

  return (
    <>
      <Container maxWidth={false}>
        <div className="accordion-style">
          <Accordion
            expanded={expanded}
            onChange={() => setExpanded(!expanded)}
          >
            <AccordionSummary
              aria-controls="panel2d-content"
              id="panel2d-header"
              className="accordion-header"
              expanded={expanded}
            >
              <Stack direction="row" spacing={2} alignItems="center">
                <Box className={classes.headerBox}>
                  <Typography
                    className={`${classes.headerText} accordionTitle`}
                  >
                    Player(s) Comparable
                  </Typography>
                </Box>
              </Stack>
            </AccordionSummary>
            <AccordionDetails>
              <Box sx={{ p: 2 }}>
                {filter.map((item, index) => (
                  <React.Fragment key={item.groupID}>
                    <Box
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "10px",
                      }}
                    >
                      <fieldset
                        style={{
                          border: `3px solid ${colorSchemaForGroups[index]}`,
                          flexGrow: 1,
                          margin: "0.5rem",
                        }}
                      >
                        <legend>
                          <Typography
                            className={`${classes.subHeaderText}`}
                            sx={{ color: `${colorSchemaForGroups[index]}` }}
                          >
                            {`Group ${item.groupID}`.toUpperCase()}
                          </Typography>
                        </legend>
                        <Card className={classes.compareGroupCard}>
                          <CardContent>
                            <Grid
                              container
                              rowSpacing={1}
                              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                            >
                              <Grid item xs={6} sm={6} lg={3}>
                                <FormControl
                                  size="small"
                                  fullWidth
                                  error={errors[index]?.event}
                                >
                                  <InputLabel id="demo-multiple-chip-label-splayer">
                                    Event
                                  </InputLabel>
                                  <Select
                                    labelId="demo-multiple-chip-label-splayer"
                                    multiple
                                    value={item.states.event}
                                    onChange={(e) =>
                                      handleChange(index, "event", e)
                                    }
                                    input={
                                      <OutlinedInput
                                        id="select-multiple-chip-splayer"
                                        label="Chip"
                                      />
                                    }
                                    renderValue={(selected) => (
                                      <Box
                                        sx={{
                                          display: "flex",
                                          flexWrap: "wrap",
                                          gap: 0.5,
                                        }}
                                      >
                                        {selected?.map((value, indexValue) => {
                                          var sEventDetails =
                                            combineEvents?.map((val, k) => {
                                              if (val.leagueId === value) {
                                                return val.eventName;
                                              }
                                            });
                                          return (
                                            <Chip
                                              key={indexValue}
                                              label={sEventDetails}
                                              clickable
                                              onDelete={(e) => {
                                                handleDeleteEntity(
                                                  index,
                                                  "event",
                                                  e,
                                                  value
                                                );
                                              }}
                                              deleteIcon={
                                                <CancelIcon
                                                  onMouseDown={(event) =>
                                                    event.stopPropagation()
                                                  }
                                                />
                                              }
                                            />
                                          );
                                        })}
                                      </Box>
                                    )}
                                    MenuProps={MenuProps}
                                    id={`idPrimaryEvent-${index}`}
                                    sx={{
                                      [`& #idPrimaryEvent-${index}`]: {
                                        fontSize: "0.8rem",
                                      },
                                    }}
                                  >
                                    {combineEvents?.map((name, index) => (
                                      <MenuItem
                                        key={name.leagueId}
                                        value={name.leagueId}
                                      >
                                        {name.eventName}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                  {errors[index]?.event && (
                                    <FormHelperText error>
                                      Event is required!
                                    </FormHelperText>
                                  )}
                                </FormControl>
                              </Grid>

                              <Grid item xs={6} sm={6} lg={1}>
                                <FormControl
                                  size="small"
                                  fullWidth
                                  error={errors[index]?.year}
                                >
                                  <InputLabel>Year</InputLabel>
                                  <Select
                                    size="small"
                                    value={item.states.year}
                                    onChange={(e) =>
                                      handleChange(index, "year", e)
                                    }
                                    label="Year"
                                    id={`idPrimaryYear-${index}`}
                                    sx={{
                                      [`& #idPrimaryYear-${index}`]: {
                                        fontSize: "0.8rem",
                                      },
                                    }}
                                    MenuProps={{
                                      PaperProps: { style: { maxHeight: 200 } },
                                    }}
                                  >
                                    {combineYearOptions?.map((elem, i) => {
                                      return (
                                        <MenuItem key={i} value={elem}>
                                          <span title={elem}>{elem}</span>
                                        </MenuItem>
                                      );
                                    })}
                                  </Select>
                                  {errors[index]?.year && (
                                    <FormHelperText error>
                                      Year is required!
                                    </FormHelperText>
                                  )}
                                </FormControl>
                              </Grid>

                              <Grid item xs={6} sm={6} lg={2}>
                                <FormControl size="small" fullWidth>
                                  <InputLabel>Position</InputLabel>
                                  <Select
                                    value={item.states.position}
                                    label="Position"
                                    id={`idPrimaryPosition-${index}`}
                                    onChange={(e) =>
                                      handleChange(index, "position", e)
                                    }
                                    sx={{
                                      [`& #idPrimaryPosition-${index}`]: {
                                        fontSize: "0.8rem",
                                      },
                                    }}
                                    MenuProps={{
                                      PaperProps: { style: { maxHeight: 200 } },
                                    }}
                                  >
                                    <MenuItem value="">
                                      <span title="None">None</span>
                                    </MenuItem>

                                    {item.states.positionOptions?.map(
                                      (name, i) => {
                                        return (
                                          <MenuItem key={i} value={name}>
                                            {name}
                                          </MenuItem>
                                        );
                                      }
                                    )}
                                  </Select>
                                </FormControl>
                              </Grid>

                              <Grid item xs={6} sm={6} lg={2}>
                                <FormControl size="small" fullWidth>
                                  <InputLabel>College or School</InputLabel>
                                  <Select
                                    size="small"
                                    label="College or School"
                                    value={item.states.collegeOrSchool}
                                    id={`idPrimaryCollege-${index}`}
                                    onChange={(e) =>
                                      handleChange(index, "collegeOrSchool", e)
                                    }
                                    sx={{
                                      [`& #idPrimaryCollege-${index}`]: {
                                        fontSize: "0.8rem",
                                      },
                                    }}
                                    MenuProps={{
                                      PaperProps: { style: { maxHeight: 200 } },
                                    }}
                                  >
                                    <MenuItem value="">
                                      <span title="None">None</span>
                                    </MenuItem>
                                    {item.states.collegeOrSchoolOptions?.map(
                                      (elem, i) => {
                                        return (
                                          <MenuItem key={i} value={elem}>
                                            <span title={elem}>{elem}</span>
                                          </MenuItem>
                                        );
                                      }
                                    )}
                                  </Select>
                                </FormControl>
                              </Grid>

                              <Grid item xs={12} sm={12} lg={4}>
                                <FormControl
                                  size="small"
                                  fullWidth
                                  error={errors[index]?.players}
                                >
                                  <InputLabel id="demo-multiple-chip-label-splayer">
                                    Players
                                  </InputLabel>
                                  <Select
                                    labelId="demo-multiple-chip-label-splayer"
                                    multiple
                                    value={item.states.players}
                                    onChange={(e) =>
                                      handleChange(index, "players", e)
                                    }
                                    input={
                                      <OutlinedInput
                                        id="select-multiple-chip-splayer"
                                        label="Chip"
                                      />
                                    }
                                    renderValue={(selected) => (
                                      <Box
                                        sx={{
                                          display: "flex",
                                          flexWrap: "wrap",
                                          gap: 0.5,
                                        }}
                                      >
                                        {selected?.map((value, indexValue) => {
                                          var sSecondaryPlayer =
                                            item.states.playersOptions?.map(
                                              (val, k) => {
                                                if (val.playerID === value) {
                                                  return val.playerName;
                                                }
                                              }
                                            );
                                          return (
                                            <Chip
                                              key={indexValue}
                                              label={sSecondaryPlayer}
                                              clickable
                                              onDelete={(e) => {
                                                handleDeleteEntity(
                                                  index,
                                                  "players",
                                                  e,
                                                  value
                                                );
                                              }}
                                              deleteIcon={
                                                <CancelIcon
                                                  onMouseDown={(event) =>
                                                    event.stopPropagation()
                                                  }
                                                />
                                              }
                                            />
                                          );
                                        })}
                                      </Box>
                                    )}
                                    MenuProps={MenuProps}
                                    id={`idFilterPlayers-${index}`}
                                    sx={{
                                      [`& #idFilterPlayers-${index}`]: {
                                        fontSize: "0.8rem",
                                      },
                                    }}
                                  >
                                    {item.states.playersOptions?.map(
                                      (name, index) => (
                                        <MenuItem
                                          key={name.playerID}
                                          value={name.playerID}
                                        >
                                          {name.playerName}
                                        </MenuItem>
                                      )
                                    )}
                                  </Select>
                                  {errors[index]?.players && (
                                    <FormHelperText error>
                                      Please choose players to get search result
                                    </FormHelperText>
                                  )}
                                </FormControl>
                              </Grid>
                            </Grid>
                          </CardContent>
                        </Card>
                      </fieldset>

                      {/* Delete button */}
                      {![1, 2].includes(item.groupID) && (
                        <IconButton
                          color="secondary"
                          onClick={() => handleDeleteGroup(item.groupID)}
                        >
                          <CancelIcon />
                        </IconButton>
                      )}
                    </Box>

                    {/* Conditionally render the Divider if the current item is not the last item */}
                    {index !== filter.length - 1 && (
                      <Divider className={classes.customDivider} sx={{ my: 2 }}>
                        VS
                      </Divider>
                    )}
                  </React.Fragment>
                ))}
              </Box>
              <Box
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  padding: "0.8rem",
                }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<SearchIcon />}
                  onClick={handleSearchButtonClick}
                  style={{ marginRight: "0.5rem" }} // Add margin to the right of the first button
                >
                  Apply
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<AddIcon />}
                  onClick={handleAddButtonClick}
                  disabled={filter?.length === 5}
                >
                  Add Group
                </Button>
              </Box>
            </AccordionDetails>
          </Accordion>
        </div>

        {/* Percentile Accordion */}
        <Box mb={2}>
          <Grid container pt={2} pb={2}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid container>
                <Grid item lg xs={12}>
                  <Paper
                    elevation={8}
                    sx={{
                      borderRadius: "16px",
                    }}
                  >
                    <Box
                      component="div"
                      display="flex"
                      flexGrow={1}
                      flexDirection="column"
                      className={classes.paperStyle}
                    >
                      <AppBar
                        position="static"
                        className={classes.appbar}
                        sx={{
                          borderTopLeftRadius: "15px !important",
                          borderTopRightRadius: "15px !important",
                        }}
                      >
                        <Hidden mdUp>
                          <Tabs
                            scrollButtons
                            allowScrollButtonsMobile
                            value={selectedTab}
                            onChange={handleChangeTab}
                            indicatorColor="primary"
                            textColor="inherit"
                            variant="scrollable"
                            aria-label="full width tabs example"
                          >
                            <Tab
                              sx={{ textTransform: "none" }}
                              label="Anthropometry"
                              {...a11yProps(0)}
                            />
                            <Tab
                              sx={{ textTransform: "none" }}
                              label="Strength And Agility"
                              {...a11yProps(1)}
                            />
                            <Tab
                              sx={{ textTransform: "none" }}
                              label="Shooting Drills"
                              {...a11yProps(2)}
                            />
                          </Tabs>
                        </Hidden>
                        <Hidden mdDown>
                          <Tabs
                            scrollButtons
                            allowScrollButtonsMobile
                            value={selectedTab}
                            onChange={handleChangeTab}
                            indicatorColor="primary"
                            textColor="inherit"
                            variant="standard"
                            aria-label="full width tabs example"
                          >
                            <Tab
                              sx={{ textTransform: "none" }}
                              label="Anthropometry"
                              {...a11yProps(0)}
                            ></Tab>
                            <Tab
                              sx={{ textTransform: "none" }}
                              label=" Strength And Agility"
                              {...a11yProps(1)}
                            />
                            <Tab
                              sx={{ textTransform: "none" }}
                              label="Shooting Drills"
                              {...a11yProps(2)}
                            />
                          </Tabs>
                        </Hidden>
                      </AppBar>
                      <SwipeableViews
                        className={classes.swipeView}
                        axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                        index={selectedTab}
                        onChangeIndex={handleChangeIndex}
                      >
                        {/* Tab 1 */}
                        <TabPanel
                          value={selectedTab}
                          index={0}
                          dir={theme.direction}
                        >
                          <IndividualPercentileAnthros
                            loading={loading}
                            anthros={stats.anthros}
                            eventId={eventId}
                            validateNumber={validateNumber}
                            anthroPercentileStats={anthroPercentileStats}
                            anthroAVGStats={anthroAVGStats}
                            colorSchemaForGroups={colorSchemaForGroups}
                            expandedGroups={expandedGroups}
                            handleGroupAccordionChange={
                              handleGroupAccordionChange
                            }
                          />
                        </TabPanel>

                        {/* Tab 2 */}
                        <TabPanel
                          value={selectedTab}
                          index={1}
                          dir={theme.direction}
                        >
                          <IndividualPercentileStrengthAndAgility
                            loading={loading}
                            strengthAndAgility={stats.strengthAndAgility}
                            eventId={eventId}
                            validateNumber={validateNumber}
                            strengthAndAgilityPercentileStats={
                              strengthAndAgilityPercentileStats
                            }
                            strengthAndAgilityAVGStats={
                              strengthAndAgilityAVGStats
                            }
                            colorSchemaForGroups={colorSchemaForGroups}
                            expandedGroups={expandedGroups}
                            handleGroupAccordionChange={
                              handleGroupAccordionChange
                            }
                          />
                        </TabPanel>

                        {/* Tab 3 */}
                        <TabPanel
                          value={selectedTab}
                          index={2}
                          dir={theme.direction}
                        >
                          <IndividualPercentileShootingDrills
                            loading={loading}
                            shootingDrills={stats.shootingDrills}
                            eventId={eventId}
                            shootingDrilsPercentileStats={
                              shootingDrilsPercentileStats
                            }
                            shootingDrilsAVGStats={shootingDrilsAVGStats}
                            colorSchemaForGroups={colorSchemaForGroups}
                            expandedGroups={expandedGroups}
                            handleGroupAccordionChange={
                              handleGroupAccordionChange
                            }
                          />
                        </TabPanel>
                      </SwipeableViews>
                    </Box>
                  </Paper>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </>
  );
};

export default IndividualCombineResult;
